// src/tiles/InterviewsBadge.jsx
import React from 'react';
import { Chip, Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

function DotScale({ valuePct = 0 }) {
  const v = Math.max(0, Math.min(100, Number(valuePct) || 0));
  const filled = Math.round(v / 10); // 10-dot scale
  return (
    <Box
      aria-label={`Interviews percentage ${v}%`}
      sx={{ display: 'inline-flex', gap: 0.4, ml: 0.75, verticalAlign: 'middle' }}
    >
      {new Array(10).fill(0).map((_, i) => (
        <Box
          key={i}
          sx={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            bgcolor: i < filled ? 'text.primary' : 'divider',
            opacity: i < filled ? 0.9 : 1
          }}
        />
      ))}
    </Box>
  );
}

export default function InterviewsBadge({ percent = 0, count = 0, showScale = true }) {
  return (
    <Chip
      size="small"
      icon={<PersonIcon />}
      label={
        <span>
          {`${percent}% (${count})`}
          {showScale && <DotScale valuePct={percent} />}
        </span>
      }
      sx={{ mr: 1 }}
    />
  );
}
